<template>
  <Content @back="$router.back()" key="exportsList">
    <template v-slot:nav_left>
      <p>分配精英机构/基地</p>
    </template>
    <template v-slot:nav_right>
      <div class="yioks_btn" @click="handleEmptyAction">分配精英机构/基地</div>
    </template>
    <template v-slot:content_right>
      <div class="base-content-warpper">
        <div class="content-inner-wrapper">
          <div class="select_wrap">
            <div class="select_box left">
              <!-- <el-select
                v-model="filterData.jixiaoType"
                class="y-input"
                clearable
                placeholder=""
                @change="changeQuery(true)"
              >
                <el-option label="全部指标类型" value=""></el-option>
                <el-option
                  v-for="item in performanceGroupTypeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select> -->
            </div>
            <div class="select_box right">
              <input
                v-model.trim="filterData.key"
                type="text"
                class="yioks_input"
                style="width: 160px"
                placeholder="请输入关键字"
                @keyup.enter="changeQuery(true)"
              />
              <div class="yioks_btn" @click="changeQuery(true)">搜索</div>
            </div>
          </div>

          <div class="list_wrap" v-if="!isShowPageLoading && pageList.length">
            <div class="table">
              <div class="thead">
                <div class="tr">
                  <div class="th seq">序号</div>
                  <div class="th">单位名称</div>
                  <div class="th">申报类型</div>
                  <div class="th">所属区域</div>
                  <div class="th">操作</div>
                </div>
              </div>
              <div class="scrollArea">
                <vue-scroll>
                  <div class="tbodyWrap">
                    <div class="tbody">
                      <div
                        class="tr"
                        v-for="(item, index) in pageList"
                        :key="index"
                      >
                        <div class="td seq">
                          <p>{{ index + 1 }}</p>
                        </div>
                        <div class="td">
                          <p :title="item.youthName">
                            {{ item.youthShortName }}
                          </p>
                        </div>
                        <div class="td">
                          <p>{{ item.stageApplyType }}</p>
                        </div>
                        <div class="td">
                          <p>{{ item.cityName }} {{ item.countyName }}</p>
                        </div>
                        <div class="td">
                          <span class="btn suc" @click="handleFileReady(item)">生成压缩包</span>
                          <span class="line m5">|</span>
                          <span
                            class="btn err"
                            @click="handleDeleteConnection(item)"
                            >解除分配</span
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </vue-scroll>
              </div>
            </div>
          </div>

          <yioks-loading v-if="isShowPageLoading" />

          <yioks-empty
            v-if="!isShowPageLoading && !pageList.length"
            tips="暂时没有数据，"
            name="点击分配精英机构/基地"
            @callback="handleEmptyAction"
          ></yioks-empty>

          <yioks-pagination :page.sync="page" :total="total"></yioks-pagination>

          <!-- 添加学校弹窗 -->
          <template v-if="isShowAllocation">
            <allocation-school
              :isShow.sync="isShowAllocation"
              :stageUuid="stageUuid"
              :expertUuid="expertUuid"
              @callback="handleAllocationResult"
            >
            </allocation-school>
          </template>

          <!-- 关系解除确认 -->
          <template v-if="isShowDeleteConfirm">
            <yioks-tips
              :showTip="isShowDeleteConfirm"
              tipMsg="确认解除当前单位吗？"
              @callback="handleDeleteCallback"
            ></yioks-tips>
          </template>

          <!-- 确认生成文件压缩包 -->
          <template v-if="isShowFileReadyConfirm">
            <yioks-tips
              :showTip="isShowFileReadyConfirm"
              tipMsg="确认生成文件压缩包？"
              @callback="handleFileReadyCallback"
            ></yioks-tips>
          </template>
        </div>
      </div>
    </template>
  </Content>
</template>

<script>
import { getExportForYouthPage, deleteYouthForExport, expertBoundFileZip } from "@/api/export";

export default {
  components: {
    Content: () => import("@/components/layout/list"),
    "yioks-tips": () => import("@/components/YioksTip"),
    "allocation-school": () =>
      import("@/views/performance/allocation/DialogForAllSchool"),
  },

  data() {
    return {
      filterData: {
        key: "",
      },
      pageList: [],
      page: 0,
      total: 0,
      pageSize: 20,

      isShowPageLoading: false,
      isShowAllocation: false,

      isShowDeleteConfirm: false,
      deleteRow: {},

      isShowFileReadyConfirm: false,
      fileRow: {},
    };
  },

  computed: {
    stageUuid() {
      const { stageUuid } = this.$route.query;
      return stageUuid || "";
    },
    expertUuid() {
      const { expertUuid } = this.$route.query;
      return expertUuid || "";
    },
    idName() {
      const { idName } = this.$route.query;
      return idName || "";
    },
  },
  watch: {
    page() {
      this.changeQuery();
    },
  },

  created() {
    this.changeQuery(true);
  },

  methods: {
    handleEmptyAction() {
      this.isShowAllocation = true;
    },

    handleAllocationResult(dialogStatus, callBackStatus) {
      if (dialogStatus) {
        if (callBackStatus) {
          this.changeQuery(true);
          this.$message.success("分配成功！");
        }
        this.isShowAllocation = false;
      } else {
        this.isShowAllocation = false;
      }
    },

    changeQuery(flag) {
      flag && (this.page = 0);
      this.$router.replace({
        path: this.$route.path,
        query: {
          ...this.$route.query,
          ...this.filterData,
          page: this.page,
        },
      });
      this.loadPageList();
    },

    // 加载页面数据
    loadPageList() {
      const paramsData = {
        ...this.filterData,
        stageUuid: this.stageUuid,
        expertUuid: this.expertUuid,
        page: this.page,
        size: this.pageSize,
      };
      this.isShowPageLoading = true;
      getExportForYouthPage(paramsData)
        .then((res) => {
          this.isShowPageLoading = false;
          if (res.code) {
            this.$msssage.error(res.msg);
            return;
          }
          const { content, totalElements } = res;
          this.pageList = content;
          this.total = totalElements;
        })
        .catch((err) => {
          this.isShowPageLoading = false;
          console.error("err", err);
        });
    },

    // 接触绑定关系 确认
    handleDeleteConnection(row) {
      this.deleteRow = row;
      this.isShowDeleteConfirm = true;
    },
    handleFileReady(row) {
      console.log('row', row)
      this.fileRow = row;
      this.isShowFileReadyConfirm = true;
    },

    handleDeleteCallback(ok) {
      if (ok) {
        const { stageUuid, youthUuid } = this.deleteRow;
        const deleteData = {
          expertUuid: this.expertUuid,
          stageUuid: stageUuid,
          youthUuid: youthUuid,
        };
        deleteYouthForExport(deleteData)
          .then((res) => {
            this.isShowDeleteConfirm = false;
            if (res.code) {
              this.$message.error(
                res.msg
              );
              return;
            }
            this.$message.success("操作成功！");
            this.changeQuery(true);
          })
          .catch((err) => {
            this.isShowDeleteConfirm = false;
            console.error("err", err);
          });
      } else {
        this.isShowDeleteConfirm = false;
        this.deleteRow = {};
      }
    },

    // 文件准备
    handleFileReadyCallback(ok) {
      if(ok) {
        const { uuid } = this.fileRow;
        console.log('uuid', uuid)
        expertBoundFileZip({uuid})
        .then(res => {
          if(res.code) {
            this.$message.error(res.msg)
            return
          }
          this.$message.success('压缩文件已经生成');
          this.isShowFileReadyConfirm = false;
          this.fileRow = {}
        })
        .catch(err => {
          console.error('err', err)
        })
      } else {
        this.isShowFileReadyConfirm = false;
        this.fileRow = {}
      }
    }
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
@import '~@/assets/css/yioks_page_table'
.list_wrap
  .table
    .th, .td
      flex 1
.seq
  flex none !important
  width 6%
.m5
  margin 0 5px
</style>
